// Angular dependencies
import { Injectable } from '@angular/core';

import { Subject, BehaviorSubject, Subscription, timer, Observable } from 'rxjs';
import { takeUntil, tap, filter, switchMap, last } from 'rxjs/operators';

import { ApiService } from '../core/upgraded-providers';

const SEASON_CHRONICLE_LAST_POST_ID = 'season.chronicle.last.post.id';
const SEASON_CHRONICLE_REQUEST_DELAY = 5 * 60 * 1000;

@Injectable()
export class SeasonChronicleService {
    _destroySbj: Subject<void> = new Subject();

    _lastPostSbj: Subject<any> = new Subject();
    lastPost$: Observable<any> = this._lastPostSbj.asObservable();

    _subscription: Subscription = null;

    set lastPostId(id: string) {
        localStorage.setItem(SEASON_CHRONICLE_LAST_POST_ID, id);
    }

    get lastPostId(): string {
        try {
            const id = localStorage.getItem(SEASON_CHRONICLE_LAST_POST_ID);

            return id;
        } catch (err) {
            console.log(err);
        }

        return null;
    }

    constructor(
        private _apiSrv: ApiService
    ) {
    }

    async getLastPost(): Promise<any> {
        try {
            const { post } = await this._apiSrv.get(`seasons/current/posts/last`);

            return post;
        } catch (err) {
            throw err;
        }
    }

    async subscribe(fn: (lastPost: any) => void) {
        this._dispose();

        if (!this._subscription) {
            this._subscribe(fn);
        };
    }

    _dispose() {
        this._destroySbj.next();
        this._destroySbj.complete();

        this._subscription = null;
    }

    _subscribe(fn: (lastPost: any) => void) {
        this._subscription = timer(0, SEASON_CHRONICLE_REQUEST_DELAY)
            .pipe(takeUntil(this._destroySbj))
            .pipe(switchMap(() => this.getLastPost()))
            .pipe(tap((lastPost) => {
                if (!this.lastPostId) {
                    this.lastPostId = lastPost._id;
                }
            }))
            .pipe(filter((lastPost) => lastPost._id !== this.lastPostId))
            .pipe(tap((lastPost) => fn(lastPost)))
            .pipe(tap((lastPost) => this._lastPostSbj.next(lastPost)))
            .subscribe();
    }
}
